module.exports = __webpack_public_path__ + "img/back-scratcher.afa09ee0.png";